export const AVAILABLE_WATERMARK_FONT_NAMES = [
  'Arial',
  'Verdana',
  'Tahoma',
  'Trebuchet MS',
  'Times New Roman',
  'Georgia',
  'Courier New',
  'Comic Sans MS',
] as const;

export type WatermarkFontName = (typeof AVAILABLE_WATERMARK_FONT_NAMES)[number];

export const DEFAULT_WATERMARK_FONT_NAME: WatermarkFontName = 'Arial';

const WATERMARK_FONT_NAME_LOOKUP = new Map<string, WatermarkFontName>(
  AVAILABLE_WATERMARK_FONT_NAMES.map(fontName => [fontName.toLowerCase(), fontName]),
);

const WATERMARK_FONT_STACK_BY_NAME: Record<WatermarkFontName, string> = {
  Arial: 'Arial, "Helvetica Neue", Helvetica, sans-serif',
  Verdana: 'Verdana, Geneva, sans-serif',
  Tahoma: 'Tahoma, Geneva, sans-serif',
  'Trebuchet MS': '"Trebuchet MS", Helvetica, sans-serif',
  'Times New Roman': '"Times New Roman", Times, serif',
  Georgia: 'Georgia, serif',
  'Courier New': '"Courier New", Courier, monospace',
  'Comic Sans MS': '"Comic Sans MS", "Comic Sans", cursive',
};

export function normalizeWatermarkFontName(fontName: string | null | undefined): WatermarkFontName {
  const key = fontName?.trim().toLowerCase();
  if (!key) {
    return DEFAULT_WATERMARK_FONT_NAME;
  }

  return WATERMARK_FONT_NAME_LOOKUP.get(key) ?? DEFAULT_WATERMARK_FONT_NAME;
}

export function toWatermarkCssFontFamily(fontName: string | null | undefined): string {
  return WATERMARK_FONT_STACK_BY_NAME[normalizeWatermarkFontName(fontName)];
}
